import * as React from "react";
import {BaseDict} from "./dict";
import {HamburgerNavigationActionButton} from "../../components"

export class HamburgerNavigationLiveChatButtonBlock extends React.Component < {
    dict : BaseDict,
    cms : any
}, {} > {
    dict: BaseDict;
    cms: any;
    className: string;

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;
        // setup cms
        this.cms = this.props.cms;
        this.className = "chat";
    }

    render() {
        return (<HamburgerNavigationActionButton class={this.className} link={this.cms.Link}/>)
    }
}